import { darken } from 'polished';
import React from 'react';
import { Colors } from '../../../ui';
import { Button } from '../../packages/controls/Button';
import { aspect } from './Aspect';
import { RenderTextField } from './RenderField';
import { RenderBorder, RenderBounds } from './RenderHelpers';
import { VisualBase } from './VisualBase';

export class ButtonVisual extends VisualBase<Button> {

    @aspect()
    private get isUp() {
        const { interaction, isPressed } = this;
        return interaction?.type === 'invoke' && !isPressed;
    }

    @aspect()
    private get isDown() {
        const { interaction, isPressed } = this;
        return interaction?.type === 'invoke' && isPressed;
    }

    @aspect()
    private get shadow() {
        const { isUp, isDown } = this;
        if (isUp) return '0px 0px 1px 0 rgba(0, 0, 0, 0.2), 0px 5px 5px 0 rgba(0, 0, 0, 0.2)';
        if (isDown) return '0px 0px 1px 0 rgba(0, 0, 0, 0.2), 0px 3px 5px 0 rgba(0, 0, 0, 0.2)';
        return '0px 0px 1px 0 rgba(0, 0, 0, 0.1), 0px 3px 5px 0 rgba(0, 0, 0, 0.1)';
    }

    @aspect()
    private get borderStyling(): any {
        const bg = this.object.background;
        return {
            width: this.object.width,
            height: this.object.height,
            boxShadow: this.shadow,
            backgroundColor: this.isDown ? darken(.05, bg) : bg,
            color: Colors.contrastTextColorFor(bg),
            borderRadius: '4px',
            transform: `translateY(${this.isUp ? -2 : 0}px)`,
            transition: 'transform 75ms ease-out, box-shadow 75ms ease-out'
        };
    }

    public render() {
        return <>
            <RenderBounds object={this.object}>
                <RenderBorder pose={this.pose} style={this.borderStyling}>
                    {!this.isBeingEdited && <RenderTextField object={this.object} name="content" />}
                </RenderBorder>
            </RenderBounds>
        </>;
    }
}
